import React from "react";
import { Wrapper, HeroButton } from "./styles";
import { useTheme } from "../Theme/ThemeProvider";

export default function MainHeading({
  toggleQrModal,
  title,
  description,
  buttonText,
}) {
  const { isDarkMode } = useTheme();
  return (
    <Wrapper isDarkMode={isDarkMode}>
      <div className="ContentWrapper">
        <div className="TitleMainHeading">{title}</div>
        <div className="DescriptionMainHeading">{description}</div>
        {buttonText && (
          <HeroButton onClick={toggleQrModal}>{buttonText}</HeroButton>
        )}
      </div>
    </Wrapper>
  );
}
